
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"170.4","height":"170.4","viewBox":"0 0 45.085 45.085","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.085 22.54c0 12.45-10.093 22.542-22.542 22.542C10.093 45.082 0 34.99 0 22.54 0 10.09 10.093-.002 22.543-.002S45.085 10.091 45.085 22.54","fill":"#90dfaa"}}),_c('path',{attrs:{"d":"M4.926 36.6c4.13 5.17 10.485 8.485 17.617 8.485 7.131 0 13.486-3.316 17.616-8.485z","fill":"#2c9984"}}),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M36.115 36.6V16.377a.59.59 0 00-.59-.59h-3.903a.59.59 0 00-.59.59V36.6zM28.761 36.6V20.378a.59.59 0 00-.59-.59H24.27a.59.59 0 00-.59.59V36.6zM21.407 36.6V24.379a.59.59 0 00-.59-.59h-3.903a.59.59 0 00-.59.59V36.6zM14.053 36.6v-8.22a.59.59 0 00-.59-.59H9.56a.59.59 0 00-.59.59v8.22z"}})]),_c('path',{attrs:{"d":"M29.812 9.57l-.818 4.018a.25.25 0 01-.455.088l-1.135-1.713-16.58 11.157-.93-1.402 16.58-11.16-1.137-1.715a.253.253 0 01.261-.386l4.017.817c.137.026.223.16.197.296","fill":"#324a5e"}})])
          )
        }
      }
    